import constants from '../constants'

export default {
  /* Navigation */
  navigationTabs: (state) => state.navigation.tabs,
  navigationTabIndex: (state) => state.navigation.activeTabIndex,
  navigationActiveTab: (state) => state.navigation.tabs[state.navigation.activeTabIndex],
  /* Date filter */
  dataFilterStartDate: (state) => state.data.filter.startDate,
  dataFilterEndDate: (state) => state.data.filter.endDate,
  dataFilterPresets: (state) => state.data.presets.system,
  dataFilterUserPresets: (state) => state.data.presets.user,
  dataCurrentDate: (state) => state.data.currentDate,
  /* Antea */
  dataAntea: (state) => state.data.antea,
  /* Events */
  dataEventCollectionFeature: (state) => state.data.events.geojson,
  dataEventSelectedEventIndex: (state) => state.data.events.selectedEventIndex,
  /* Map */
  mapControlsLayers: (state) => state.map.controls.layers,
  mapDataUpdate: (state) => state.map.data.update,
  /* Weather */
  dataWeatherCurrent: (state) => state.data.weather.current,
  dataWeatherTimeSeries: (state) => state.data.weather.timeseries,
  showWeatherIcon: (state) => state.map.controls.layers.find(layer => layer.id == constants.MAP_LAYER_WEATHER_ID).visible,
  /* Parking */
  dataParkingDatasets: (state) => state.data.parking.datasets,
  dataParkingTimeSeries: (state) => state.data.parking.timeseries,
  dataTimeSeries: (state) => {
    let labels = [], datasets = []
    let scales = {
      xAxes: [{ display: true, type: 'time', time: { unit: 'day'} }],
      yAxes: []
    }
    if (state.data.weather.timeseries.datasets
      && state.data.weather.timeseries.datasets.length > 0) {
      labels = state.data.weather.timeseries.labels
      datasets.push({
        ...state.data.weather.timeseries.datasets[0],
        yAxisID: state.data.weather.timeseries.datasets[0].label
      })
      scales.yAxes.push({
        id: state.data.weather.timeseries.datasets[0].label,
        position: 'left',
        ticks: { beginAtZero: true, padding: 25, suggestedMax: 37 },
        scaleLabel: { display: true, labelString: 'Temperatuur in °C' }
      })
    }
    if (state.data.parking.timeseries.datasets
      && state.data.parking.timeseries.datasets.length > 0) {
      // Push labels if we don't already have them.
      if (labels.length == 0) {
        labels = state.data.parking.timeseries.labels
      }
      // Push dataset
      datasets.push({
        ...state.data.parking.timeseries.datasets[0],
        yAxisID: state.data.parking.timeseries.datasets[0].label
      })
      // Add scale
      scales.yAxes.push({
        id: state.data.parking.timeseries.datasets[0].label,
        position: scales.yAxes.length == 0 ? 'left' : 'right',
        ticks: { beginAtZero: false, padding: 25, suggestedMax:900 },
        scaleLabel: { display: true, labelString: 'Aantal beschikbare plekken' }
      })
    }
    return {
      data: { labels: labels, datasets: datasets },
      options: { scales: scales }
    }
  },
  /* Experience Sampling */
  dataMetricWireSelectedSurvey: (state) => state.data.metricwire.selectedSurvey,
  dataMetricWireSelectedCategories: (state) => state.data.metricwire.surveyCategories,
  /* Travel time */
  dataTravelTimeTimeSeries: (state) => state.data.traveltime.timeseries,
  dataTravelIntensityTimeSeries: (state) => state.data.travelintensity.timeseries,

  dataExperienceSamplingStudies: (state) => state.data.experienceSampling.workspace.studies,
  dataExperienceSamplingSurveys: (state) => state.data.experienceSampling.workspace.selectedStudy.surveys,
  chartExperienceSamplingQuestions: (state) => state.data.experienceSampling.workspace.selectedStudy.selectedSurvey.questions,
  chartExperienceSamplingSelectedQuestion: (state) => state.data.experienceSampling.workspace.selectedStudy.selectedSurvey.selectedQuestion,
  chartExperienceSamplingSurveyChart: (state) => state.data.experienceSampling.chart,
  /* Layers */
  mapLayerParking: (state) => findLayer(state, { layerId: constants.MAP_LAYER_PARKING_ID }),
  mapLayerTrafficIntensity: (state) => findLayer(state, { layerId: constants.MAP_LAYER_TRAFFIC_ID }),
}

function findLayer(state, { layerId }) {
  const layers = state.map.data.layers
  for (var i = 0; i < layers.length; i++) {
    if (layers[i].id === layerId) {
      return layers[i]
    }
  }
}
